import { Injectable } from '@angular/core';
import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class UserDataService {

    institutionsList: Array<any>;

    constructor() { }

    
}  